module.exports = __webpack_public_path__ + "static/media/calendarSidebarSelected.6817e9b8.svg";